module.exports = __webpack_public_path__ + "fonts/Barlow-Black.04f4e1e8.woff2";